export default {
  namespaced: true,
  state: {
    isReconnect: false, // 是否正在处理 WS 重连后的消息同步
    historyGeneration: 0
  },
  getters: {},
  actions: {},
  mutations: {
    setIsReconnect(state, payload) {
      state.isReconnect = payload;
    },
    setHistoryGeneration(state, payload) {
      state.historyGeneration = payload;
    }
  }
};
